/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![RemixIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABaUlEQVR4nN2VzUoDQQzHVx9BKWh9ocU6SQqOkyKexSfocU99ooIHQQuKL2APPoGIeFMvPWgls1PYj9l0d48NLD0k8/9N0kySJDtrhvgZiNfRD91TOc79GOIF4sS0BohII4B4rcTNOmeTWjsw5F5iAA8BHhp0U4O8Ep8hd9ZJHJCXeWnCbwWwMYHkAH7ofnN0r6fWHmmAjd8Qf/UST6QcCqCNXxXfJpBl2b7PAN1v0rbmqbWDol+6xhA/xs6ORvYkAD6i4kRXh5r4NjPkbsLZecy/B+ju+4qPx5fHgPzuzwOfR+h8EXr4TYK7iKelsro7uWwtCJBvJQBxct1fnJfW2oNoIJD7lKBixxTNz5zCDIqJq2UF4r/QfvX0knp7aq3cBGj9gNKu4mIG+Tt0wFADpH3EPYB4ER7JVANA33ciyyIH8MpPxUomUF447W9eEZk1bS5Qlk+1u1STZSHzXP6T4szRNlzTbNoN+wcE905zc9fm6gAAAABJRU5ErkJggg==)
 */
export const RemixIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M6 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V5.41l-6.64 6.64A4.66 4.66 0 0 0 4 15.35V17a3 3 0 0 0 3 3 1 1 0 1 1 0 2 5 5 0 0 1-5-5v-1.66c0-1.76.7-3.46 1.95-4.7L10.59 4H7a1 1 0 0 1-1-1Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M18 21a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-6a1 1 0 1 1 2 0v3.59l6.64-6.64A4.66 4.66 0 0 0 20 8.65V7a3 3 0 0 0-3-3 1 1 0 1 1 0-2 5 5 0 0 1 5 5v1.66c0 1.76-.7 3.46-1.95 4.7L13.41 20H17a1 1 0 0 1 1 1Z"
        className={colorClass}
      />
    </svg>
  );
};
